module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "characters"
    }
  }, [_c('h1', {
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_vm._v("Characters")]), _vm._v(" "), _c('p', [_vm._v("Mr John Ware – ex schoolteacher, keen gardener, in 60s, absent-minded professor type,")]), _vm._v(" "), _c('p', [_vm._v("Nick Mullens – in 30s, great with children, good looking, enthusiastic, friendly and dedicated,")]), _vm._v(" "), _c('p', [_vm._v("Bentley Family:")]), _vm._v(" "), _c('p', [_vm._v("Finn, 12 years; Nigel, 10 years; Maree, 8 years")]), _vm._v(" "), _c('p', [_vm._v("Mother Yvonne; Father Thomas")]), _vm._v(" "), _c('p', [_vm._v("Grant Family:")]), _vm._v(" "), _c('p', [_vm._v("Beau, 14 years; Taj, 10 years; Ramona, 7 years")]), _vm._v(" "), _c('p', [_vm._v("Lui Family – Yen Chun, 10 years")]), _vm._v(" "), _c('p', [_vm._v("Mother Helen")]), _vm._v(" "), _c('p', [_vm._v("Grandmother – a physicist")]), _vm._v(" "), _c('p', [_vm._v("Winston Family:")]), _vm._v(" "), _c('p', [_vm._v("Levi, 9 years; Jacob, 13 years; Maddie, 9 years")]), _vm._v(" "), _c('p', [_vm._v("Dog Sam")]), _vm._v(" "), _c('p', [_vm._v("Artish, 12 years – from Indian background, Finn’s school friend.")]), _vm._v(" "), _c('p', [_vm._v("Mr Arizi – doughnut shop owner, funny, generous")]), _vm._v(" "), _c('p', [_vm._v("Wife Gloria and two small children")]), _vm._v(" "), _c('p', [_vm._v("Gremlins – Sam")]), _vm._v(" "), _c('p', [_vm._v("Sis")]), _vm._v(" "), _c('p', [_vm._v("Seth")]), _vm._v(" "), _c('p', [_vm._v("Mr Sean Hoiles – mean teacher")]), _vm._v(" "), _c('p', [_vm._v("Local Golden Press Reporter Rod Forbes and Photographer Enzo")]), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticStyle: {
      "margin": "auto"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "9"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', {
    staticClass: "odd"
  }, [_c('td', {
    staticStyle: {
      "padding-top": "0px",
      "padding-left": "4px"
    }
  }, [_c('p', [_vm._v("A robot is a machine – especially one programmable by a computer – capable of carrying out a complex series of actions automatically.")]), _vm._v(" "), _c('p', [_vm._v("Robots can be guided by an external control device or the control may be embedded within. Robots may be constructed to take on human form but most robots are machines designed to perform a task with no regard to how they look.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "padding-top": "20px",
      "text-align": "center"
    }
  }, [_vm._v("Source: Wikipedia")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a654880","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch005.vue
// module id = 75
// module chunks = 0